import { createSelector } from '@reduxjs/toolkit'
import type { RootState } from '@store/index'
import type { BillingState } from '@store/reducers/billing.reducer'

const selectBillingState = (state: RootState): BillingState => state.billing

export const selectLedger = createSelector(
  [selectBillingState],
  (billing) => billing.ledger,
)

export const selectLedgerCount = createSelector(
  [selectBillingState],
  (billing) => billing.ledgerCount,
)

export const selectInvoices = createSelector(
  [selectBillingState],
  (billing) => billing.invoices,
)

export const selectInvoiceCount = createSelector(
  [selectBillingState],
  (billing) => billing.invoiceCount,
)

export const selectSelectedInvoices = createSelector(
  [selectBillingState],
  (billing) => billing.selectedInvoices,
)

export const selectPaymentHistory = createSelector(
  [selectBillingState],
  (billing) => billing.paymentHistory,
)

export const selectPaymentHistoryCount = createSelector(
  [selectBillingState],
  (billing) => billing.paymentHistoryCount,
)

export const selectTransactions = createSelector(
  [selectBillingState],
  (billing) => billing.transactions,
)

export const selectTransactionCount = createSelector(
  [selectBillingState],
  (billing) => billing.transactionCount,
)

export const selectPatients = createSelector(
  [selectBillingState],
  (billing) => billing.patients,
)

export const selectPatientARAnalytics = createSelector(
  [selectBillingState],
  (billing) => billing.patientARAnalytics,
)

export const selectInsuranceARAnalytics = createSelector(
  [selectBillingState],
  (billing) => billing.insuranceARAnalytics,
)

export const selectARAgingReport = createSelector(
  [selectBillingState],
  (billing) => billing.arAgingReport,
)

export const selectBillingError = createSelector(
  [selectBillingState],
  (billing) => billing.error,
)

export const selectHasSelectedInvoices = createSelector(
  [selectSelectedInvoices],
  (selectedInvoices) => selectedInvoices.length > 0,
)

export const selectBillingLoadingFlags = createSelector(
  [selectBillingState],
  (billing) => ({
    loadingLedger: billing.loadingLedger,
    loadingInvoices: billing.loadingInvoices,
    loadingPaymentHistory: billing.loadingPaymentHistory,
    loadingTransactions: billing.loadingTransactions,
    loadingPatients: billing.loadingPatients,
    loadingPatientARAnalytics: billing.loadingPatientARAnalytics,
    loadingInsuranceARAnalytics: billing.loadingInsuranceARAnalytics,
    loadingARAging: billing.loadingARAging,
  }),
)
